var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508.1 508.1",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 0.2,
    style: {
      fill: "#334A5E"
    },
    width: 485.6,
    height: 56.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000334"
    },
    d: "M0,432.7v54c0,11.7,9.5,21.2,21.2,21.2h465.7c11.7,0,21.2-9.5,21.2-21.2v-54H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 56.4,
    style: {
      fill: "#0e0d0b"
    },
    width: 508,
    height: 376.3
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#40596B"
    },
    points: "0,56.4 69,56.4 69,17.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0e0d0b"
    },
    points: "69,17.6 11.2,0.2 11.2,50 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#40596B"
    },
    points: "508,56.4 439,56.4 439,17.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0e0d0b"
    },
    points: "439,17.6 496.8,0.2 496.8,50 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#40596B"
    },
    cx: 154.3,
    cy: 149.5,
    r: 20.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#40596B"
    },
    cx: 353.7,
    cy: 149.5,
    r: 20.1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000334"
    },
    d: "M376.7,251.2c-0.3,16.7-4.1,33.4-11.4,49.4c-20.3,43.9-62.9,71.2-111.3,71.2s-91-27.3-111.3-71.2 c-7.4-16-11.1-32.7-11.4-49.4h-17c0.3,19.1,4.6,38.2,13,56.5c23.1,50,71.6,81,126.7,81s103.6-31.1,126.7-81 c8.4-18.2,12.7-37.4,13-56.5L376.7,251.2L376.7,251.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M254,377.5c-55.1,0-103.6-31.1-126.7-81s-15.2-107.1,20.5-149c3-3.6,8.4-4,11.9-1c3.6,3,4,8.4,1,11.9 c-31.4,36.8-38.3,87-18,130.9s62.9,71.2,111.3,71.2s91-27.3,111.3-71.2s13.4-94.1-18-130.9c-3-3.6-2.6-8.9,1-11.9s8.9-2.6,11.9,1 c35.7,41.9,43.6,99,20.5,149C357.6,346.4,309.1,377.5,254,377.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.d2dd6dca24126198482a737af2b75853.svg";
export { ForwardRef as ReactComponent };